import { trim } from "lodash-es";

export const normalizePath = (path: string, trailingSlash = false) => {
  const trimmed = trim(path.trim(), "/");

  if (!trimmed) {
    return "/";
  }

  return `/${trimmed}${trailingSlash ? "/" : ""}`;
};
